// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  font-size: 25px;
  margin-bottom: 5px;
  text-align: center !important;
}

.subHeading {
  text-align: center;
  color: #717171;
}

.shadow {
  width: 160px;
}

.shadowStandard {
  width: 100%;
}

.shadowStandard .control-select-inner {
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  border-radius: 4px;
  padding: 0.5rem;
}

.shadowStandard .control-select-filter-inner {
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  border-radius: 4px;
  padding: 0.5rem;
}

.header2 .block-limiter {
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
}

.header2 .brandhotelselector {
  margin-top: 5px;
}

.floatRight {
  float: right;
}

.marginBottom20 {
  margin-bottom: 20px;
}

.calender-selection {
  margin-top: 5px;
}

.calender-selection .control-select-men {
  display: inline-block;
  float: left;
}

.calender-selection .control-select-filter-men {
  display: inline-block;
  float: left;
}

.assesmenttxt {
  color: #717171;
}

.assessmentDiv {
  margin-top: 1.2rem;
  margin-bottom: 1.2rem;
}

.assesmentUnderline {
  text-decoration: underline;
}

.description-container {
  display: block;
  float: left;
  width: 60%;
  color: #000;
  padding-top: 15px;
}

.description-container b {
  margin-bottom: 10px;
  color: #000;
  display: block;
}

.dashboard-header-group-inner {
  min-width: 140px;
  margin: 10px;
  flex: 1 1 auto;
}

.listRankingContainer .block-limiter {
  padding: 0 12px 12px 12px;
}

.listRankingContainer .list-ranking-item {
  width: 100%;
  margin-top: 20px;
}

.listRankingContainer .list-ranking-item.layout-default {
  padding: 15px 15px 15px 15px;
}

.graph-block {
  width: 100%;
}

.displayInline {
  display: inline !important;
}

.list-ranking-item-chart span {
  font-size: 12px;
  font-weight: bold;
}

.list-ranking-item-chart span.intent-success {
  color: #82bd7a;
}

.list-ranking-item-chart span.intent-danger {
  color: #d68077;
}

.list-ranking-item-chart span.intent-warning {
  color: #ffb71a;
}

.mainCat .list-ranking-item-title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 15px;
}

.listRankingContainer .list-ranking-item.layout-default:first-child {
  flex: 0 0 135px !important;
}

.list-ranking-item-title {
  text-transform: capitalize;
}

.control-select-pillbutton-item SPAN {
  font-size: 16px;
}

.control-select-filter-pillbutton-item SPAN {
  font-size: 16px;
}

.chart-trend {
  margin-top: 20px;
}

.subHeadingH3 {
  margin-bottom: 5px;
}

.deptPerformanceContainer {
  margin-top: 20px;
}

.deptPerformanceContainer .block-limiter {
  padding: 0 10px 10px 10px;
}

.deptPerformanceTableContainer .block-limiter {
  padding: 0 0px 0px 0px;
}

.deptPerformance {
  border-collapse: collapse;
  width: 100%;
  font-size: 16px;
}

.deptPerformance th {
  text-transform: uppercase;
}

.deptPerformance th:first-child {
  width: 50%;
}

.deptPerformance th, .deptPerformance td {
  text-align: left;
  padding: 15px;
}

.deptPerformance tr {
  border-bottom: 1px solid rgba(51, 51, 51, 0.15);
}

.deptPerformance tr:nth-child(even) {
  background-color: #f8f8f8;
}

.deptPerformance tr:last-child {
  background-color: #fff;
}

.iconTrending {
  display: block;
  float: right;
  width: 10%;
  text-align: right;
}

.iconTrending svg {
  height: 16px;
  width: 25px;
  position: relative;
  bottom: 0px;
}

.sortLow {
  display: block;
  float: right;
  width: 22%;
  color: #717171;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-align: right;
}

.sortHigh {
  display: block;
  float: right;
  width: 22%;
  color: #717171;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-align: right;
}

.activeSort {
  color: #000;
  font-weight: 600;
}

.sortContainer {
  display: block;
  margin-top: 30px;
}

.hide {
  display: none;
}

.fullWidthSelect {
  width: 100% !important;
}

.shadow {
  width: 160px;
}

.shadowStandard {
  width: 100%;
}

.shadowStandard .control-select-inner {
  box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13);
  border-radius: 6px;
  padding: 0.5rem;
}

.shadowStandard .control-select-filter-inner {
  box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13);
  border-radius: 6px;
  padding: 0.5rem;
}

.noShadow {
  box-shadow: none;
}

.deptPerformanceContainer span {
  text-align: left;
  color: #717171;
}

.NoResults {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.noResults {
  height: 100%;
  width: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.noResultFont {
  letter-spacing: 0.36px;
  color: #667085 !important;
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./styles.scss"],"names":[],"mappings":"AACA;EAAG,eAAA;EAAiB,kBAAA;EAAmB,6BAAA;AAGvC;;AAFA;EAAY,kBAAA;EAAoB,cAAA;AAOhC;;AANA;EAAQ,YAAA;AAUR;;AATA;EAAgB,WAAA;AAahB;;AAZA;EACI,mDAAA;EACA,kBAAA;EACA,eAAA;AAeJ;;AAbA;EACI,mDAAA;EACA,kBAAA;EACA,eAAA;AAgBJ;;AAbA;EAAwB,iBAAA;EAAkB,kBAAA;EAAmB,mBAAA;AAmB7D;;AAlBA;EAA6B,eAAA;AAsB7B;;AArBA;EAAY,YAAA;AAyBZ;;AAxBA;EAAgB,mBAAA;AA4BhB;;AA3BA;EAAoB,eAAA;AA+BpB;;AA7BA;EAAwC,qBAAA;EAAuB,WAAA;AAkC/D;;AAjCA;EAA+C,qBAAA;EAAuB,WAAA;AAsCtE;;AApCA;EAAc,cAAA;AAwCd;;AAvCA;EAAe,kBAAA;EAAoB,qBAAA;AA4CnC;;AA3CA;EAAoB,0BAAA;AA+CpB;;AA9CA;EAAuB,cAAA;EAAgB,WAAA;EAAY,UAAA;EAAY,WAAA;EAAY,iBAAA;AAsD3E;;AArDA;EAAyB,mBAAA;EAAqB,WAAA;EAAa,cAAA;AA2D3D;;AA1DA;EAA+B,gBAAA;EAAiB,YAAA;EAAa,cAAA;AAgE7D;;AA/DA;EAAqC,yBAAA;AAmErC;;AAlEA;EAAyC,WAAA;EAAa,gBAAA;AAuEtD;;AAtEA;EAAwD,4BAAA;AA0ExD;;AAzEA;EAAa,WAAA;AA6Eb;;AA5EA;EAAe,0BAAA;AAgFf;;AA/EA;EAA8B,eAAA;EAAiB,iBAAA;AAoF/C;;AAnFA;EAA6C,cAAA;AAuF7C;;AAtFA;EAA4C,cAAA;AA0F5C;;AAzFA;EAA6C,cAAA;AA6F7C;;AA5FA;EAAkC,iBAAA;EAAmB,eAAA;EAAiB,mBAAA;AAkGtE;;AAjGA;EAAoE,0BAAA;AAqGpE;;AApGA;EAAyB,0BAAA;AAwGzB;;AAvGA;EAAqC,eAAA;AA2GrC;;AA1GA;EAA4C,eAAA;AA8G5C;;AA7GA;EAAa,gBAAA;AAiHb;;AAhHA;EAAc,kBAAA;AAoHd;;AAnHA;EAA0B,gBAAA;AAuH1B;;AAtHA;EAA0C,yBAAA;AA0H1C;;AAzHA;EAA+C,sBAAA;AA6H/C;;AA5HA;EAAiB,yBAAA;EAA0B,WAAA;EAAa,eAAA;AAkIxD;;AAjIA;EAAoB,yBAAA;AAqIpB;;AApIA;EAAiC,UAAA;AAwIjC;;AAvIA;EAA0C,gBAAA;EAAiB,aAAA;AA4I3D;;AA3IA;EAAoB,+CAAA;AA+IpB;;AA9IA;EAAsC,yBAAA;AAkJtC;;AAjJA;EAAiC,sBAAA;AAqJjC;;AApJA;EAAc,cAAA;EAAe,YAAA;EAAa,UAAA;EAAY,iBAAA;AA2JtD;;AA1JA;EAAkB,YAAA;EAAc,WAAA;EAAa,kBAAA;EAAoB,WAAA;AAiKjE;;AAhKA;EAAS,cAAA;EAAe,YAAA;EAAa,UAAA;EAAW,cAAA;EAAgB,eAAA;EAAgB,gBAAA;EAAgB,iBAAA;EAAiB,iBAAA;AA2KjH;;AA1KA;EAAU,cAAA;EAAe,YAAA;EAAa,UAAA;EAAY,cAAA;EAAe,eAAA;EAAgB,gBAAA;EAAgB,iBAAA;EAAiB,iBAAA;AAqLlH;;AApLA;EAAY,WAAA;EAAW,gBAAA;AAyLvB;;AAxLA;EAAe,cAAA;EAAe,gBAAA;AA6L9B;;AA5LA;EAAM,aAAA;AAgMN;;AA/LA;EAAiB,sBAAA;AAmMjB;;AAlMA;EAAQ,YAAA;AAsMR;;AArMA;EAAgB,WAAA;AAyMhB;;AAxMA;EACI,mFAAA;EACA,kBAAA;EACA,eAAA;AA2MJ;;AAzMA;EACI,mFAAA;EACA,kBAAA;EACA,eAAA;AA4MJ;;AA1MA;EAAU,gBAAA;AA8MV;;AA7MA;EAA+B,gBAAA;EAAkB,cAAA;AAkNjD;;AAjNA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAoNJ;;AAlNA;EACI,YAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAqNJ;;AAnNA;EACI,sBAAA;EACA,yBAAA;EACA,gBAAA;AAsNJ","sourcesContent":["h1 {\n  font-size: 25px;\n  margin-bottom: 5px;\n  text-align: center !important;\n}\n\n.subHeading {\n  text-align: center;\n  color: #717171;\n}\n\n.shadow {\n  width: 160px;\n}\n\n.shadowStandard {\n  width: 100%;\n}\n\n.shadowStandard .control-select-inner {\n  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;\n  border-radius: 4px;\n  padding: 0.5rem;\n}\n\n.shadowStandard .control-select-filter-inner {\n  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;\n  border-radius: 4px;\n  padding: 0.5rem;\n}\n\n.header2 .block-limiter {\n  padding-left: 0px;\n  padding-right: 0px;\n  padding-bottom: 0px;\n}\n\n.header2 .brandhotelselector {\n  margin-top: 5px;\n}\n\n.floatRight {\n  float: right;\n}\n\n.marginBottom20 {\n  margin-bottom: 20px;\n}\n\n.calender-selection {\n  margin-top: 5px;\n}\n\n.calender-selection .control-select-men {\n  display: inline-block;\n  float: left;\n}\n\n.calender-selection .control-select-filter-men {\n  display: inline-block;\n  float: left;\n}\n\n.assesmenttxt {\n  color: #717171;\n}\n\n.assessmentDiv {\n  margin-top: 1.2rem;\n  margin-bottom: 1.2rem;\n}\n\n.assesmentUnderline {\n  text-decoration: underline;\n}\n\n.description-container {\n  display: block;\n  float: left;\n  width: 60%;\n  color: #000;\n  padding-top: 15px;\n}\n\n.description-container b {\n  margin-bottom: 10px;\n  color: #000;\n  display: block;\n}\n\n.dashboard-header-group-inner {\n  min-width: 140px;\n  margin: 10px;\n  flex: 1 1 auto;\n}\n\n.listRankingContainer .block-limiter {\n  padding: 0 12px 12px 12px;\n}\n\n.listRankingContainer .list-ranking-item {\n  width: 100%;\n  margin-top: 20px;\n}\n\n.listRankingContainer .list-ranking-item.layout-default {\n  padding: 15px 15px 15px 15px;\n}\n\n.graph-block {\n  width: 100%;\n}\n\n.displayInline {\n  display: inline !important;\n}\n\n.list-ranking-item-chart span {\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.list-ranking-item-chart span.intent-success {\n  color: #82bd7a;\n}\n\n.list-ranking-item-chart span.intent-danger {\n  color: #d68077;\n}\n\n.list-ranking-item-chart span.intent-warning {\n  color: #ffb71a;\n}\n\n.mainCat .list-ranking-item-title {\n  font-weight: bold;\n  font-size: 18px;\n  margin-bottom: 15px;\n}\n\n.listRankingContainer .list-ranking-item.layout-default:first-child {\n  flex: 0 0 135px !important;\n}\n\n.list-ranking-item-title {\n  text-transform: capitalize;\n}\n\n.control-select-pillbutton-item SPAN {\n  font-size: 16px;\n}\n\n.control-select-filter-pillbutton-item SPAN {\n  font-size: 16px;\n}\n\n.chart-trend {\n  margin-top: 20px;\n}\n\n.subHeadingH3 {\n  margin-bottom: 5px;\n}\n\n.deptPerformanceContainer {\n  margin-top: 20px;\n}\n\n.deptPerformanceContainer .block-limiter {\n  padding: 0 10px 10px 10px;\n}\n\n.deptPerformanceTableContainer .block-limiter {\n  padding: 0 0px 0px 0px;\n}\n\n.deptPerformance {\n  border-collapse: collapse;\n  width: 100%;\n  font-size: 16px;\n}\n\n.deptPerformance th {\n  text-transform: uppercase;\n}\n\n.deptPerformance th:first-child {\n  width: 50%;\n}\n\n.deptPerformance th, .deptPerformance td {\n  text-align: left;\n  padding: 15px;\n}\n\n.deptPerformance tr {\n  border-bottom: 1px solid rgba(51, 51, 51, 0.15);\n}\n\n.deptPerformance tr:nth-child(even) {\n  background-color: #f8f8f8;\n}\n\n.deptPerformance tr:last-child {\n  background-color: #fff;\n}\n\n.iconTrending {\n  display: block;\n  float: right;\n  width: 10%;\n  text-align: right;\n}\n\n.iconTrending svg {\n  height: 16px;\n  width: 25px;\n  position: relative;\n  bottom: 0px;\n}\n\n.sortLow {\n  display: block;\n  float: right;\n  width: 22%;\n  color: #717171;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  text-align: right;\n}\n\n.sortHigh {\n  display: block;\n  float: right;\n  width: 22%;\n  color: #717171;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  text-align: right;\n}\n\n.activeSort {\n  color: #000;\n  font-weight: 600;\n}\n\n.sortContainer {\n  display: block;\n  margin-top: 30px;\n}\n\n.hide {\n  display: none;\n}\n\n.fullWidthSelect {\n  width: 100% !important;\n}\n\n.shadow {\n  width: 160px;\n}\n\n.shadowStandard {\n  width: 100%;\n}\n\n.shadowStandard .control-select-inner {\n  box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13);\n  border-radius: 6px;\n  padding: 0.5rem;\n}\n\n.shadowStandard .control-select-filter-inner {\n  box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13);\n  border-radius: 6px;\n  padding: 0.5rem;\n}\n\n.noShadow {\n  box-shadow: none;\n}\n\n.deptPerformanceContainer span {\n  text-align: left;\n  color: #717171;\n}\n\n.NoResults {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.noResults {\n  height: 100%;\n  width: 70%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.noResultFont {\n  letter-spacing: 0.36px;\n  color: #667085 !important;\n  margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
